import React, { SyntheticEvent, useEffect, useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";

const Homepage = () => {
  const loaderData = useLoaderData();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  // const goToLogin: React.EventHandler<SyntheticEvent> = (e) => {
  //   setLoading(true);
  //   navigate("/login");
  // };

  if (loading) {
    return <div>Loading!</div>;
  } else {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center full-viewport-height shadows fade-in">
        <div className="homepage-logo"></div>
        <button
          className="homepage-button"
          onClick={() => {
            navigate("/menu", {
              state: {},
            });
          }}
        >
          ENTER
        </button>
      </div>
    );
  }
};

export default Homepage;
